function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useContext } from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../reducers/modal.reducer';
import { cmsActions } from '../../../reducers/cms.reducer';
import ArticlesEditData from './ArticlesEditData.context';
import UploadImage from '../../common/assets/UploadImage.modal';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Cropper from '../../common/Cropper.react';
import Button from '../../common/Button.react';
import AzureBlob from '../../common/AzureBlob.react';
import AltTag from '../../common/form/AltTag.react';
import Label from '../../common/form/Label.react';
var ArticleImages = function ArticleImages(_ref) {
  var _hero$selected;
  var addModalAction = _ref.addModalAction,
    removeModalAction = _ref.removeModalAction,
    articleAssetAction = _ref.articleAssetAction;
  var _useContext = useContext(ArticlesEditData),
    _useContext2 = _slicedToArray(_useContext, 2),
    state = _useContext2[0],
    setState = _useContext2[1];
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var articleID = state.articleID,
    hero = state.hero,
    articleType = state.articleType,
    archived = state.archived;
  var _useState3 = useState({
      visible: false,
      asset: null,
      assetID: null,
      reCrop: false,
      filename: null
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    cropper = _useState4[0],
    setCropper = _useState4[1];
  if (articleType === 'faq' || articleType === 'video') return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Banner Images"
  }), /*#__PURE__*/React.createElement(CardBody, null, hero.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "a-img__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a-img__img--body",
    style: {
      width: 1400,
      height: 490
    }
  }, /*#__PURE__*/React.createElement(AzureBlob, {
    filename: hero[selected].filename,
    assetID: hero[selected].assetID,
    key: "heroImage".concat(selected)
  })), /*#__PURE__*/React.createElement(Label, {
    label: "Alt Tag"
  }), /*#__PURE__*/React.createElement(AltTag, {
    altTag: (_hero$selected = hero[selected]) === null || _hero$selected === void 0 ? void 0 : _hero$selected.altTag,
    tagType: "article-banner",
    appType: "pos",
    selected: selected,
    articleID: articleID,
    onChange: function onChange(e) {
      var tmp = _toConsumableArray(hero);
      tmp[selected].altTag = e.target.value;
      setState(_objectSpread(_objectSpread({}, state), {}, {
        hero: tmp
      }));
    }
  })), !archived && /*#__PURE__*/React.createElement("div", {
    className: "a-img__controls"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      articleAssetAction({
        formData: {
          assetID: hero[selected]._id,
          type: 'articleHero',
          articleID: articleID,
          filename: hero[selected].filename
        },
        method: 'delete'
      });
    }
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Re-Crop",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        assetID: hero[selected].assetID,
        visible: true,
        reCrop: true,
        filename: hero[selected].filename
      }));
    }
  }))), ((hero === null || hero === void 0 ? void 0 : hero.length) === 0 || articleType === 'project') && !archived && /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, hero.map(function (x, i) {
    return /*#__PURE__*/React.createElement(Button, {
      label: i + 1,
      onClick: function onClick() {
        setSelected(i);
      },
      style: {
        width: 50,
        minWidth: 50
      },
      key: "selected-".concat(x._id),
      type: i === selected ? 'primary' : 'cancel'
    });
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Add",
    permission: "edit-pos-articles",
    onClick: function onClick() {
      addModalAction({
        component: /*#__PURE__*/React.createElement(UploadImage, {
          onUploaded: function onUploaded(img) {
            setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
              asset: img,
              visible: true,
              reCrop: false,
              filename: null
            }));
            removeModalAction();
          },
          disableSelectImageType: true
        })
      });
    }
  })), /*#__PURE__*/React.createElement(Cropper, {
    visible: cropper.visible,
    type: articleType,
    asset: cropper.asset,
    assetID: cropper.assetID,
    onClose: function onClose() {
      return setCropper(_objectSpread(_objectSpread({}, cropper), {}, {
        visible: false
      }));
    },
    onCrop: function onCrop(_ref2) {
      var crop = _ref2.crop,
        assetID = _ref2.assetID;
      articleAssetAction({
        formData: {
          id: null,
          type: 'articleHero',
          articleID: articleID,
          assetID: assetID,
          filename: cropper.filename,
          crop: {
            x: crop.x,
            y: crop.y,
            w: crop.width,
            h: crop.height
          }
        },
        method: cropper.reCrop ? 'put' : 'post'
      });
      setCropper({
        visible: false,
        asset: null,
        assetID: null,
        reCrop: false,
        filename: null
      });
    }
  }))));
};
var mdtp = {
  addModalAction: modalActions.add,
  removeModalAction: modalActions.remove,
  articleAssetAction: cmsActions.articleAsset
};
export default connect(null, mdtp)(ArticleImages);